import React from "react";
import { styled } from "styled-components";
import { tokens } from "./tokens";
import SegmentedControl from "./SegmentedControl";
import { NameMode } from "./data";

/**
 * Display-name (AV-DL-13) ↔ roster-name (dl13) toggle. Lives in the page body
 * (not the fixed-height PageHeader) so it wraps cleanly on narrow screens, and
 * is shared by the fleet grid and the tractor detail so both stay in sync.
 */
const MODES: readonly { value: NameMode; label: string }[] = [
  { value: "display", label: "Display" },
  { value: "roster", label: "Roster" },
];

interface NameToggleProps {
  value: NameMode;
  onChange: (mode: NameMode) => void;
}

const NameToggle: React.FC<NameToggleProps> = ({ value, onChange }) => (
  <Wrap>
    <Label>Name</Label>
    <SegmentedControl
      options={MODES}
      value={value}
      onChange={onChange}
      ariaLabel="Tractor name display"
    />
  </Wrap>
);

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Label = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${tokens.slate};
`;

export default NameToggle;
